<template>
	<div id="detail" class="middle-row between" style="height:800px;">
		<div class="detial-left" style="width:20%;margin-right: 5px;height:100%;position: relative;">
			<div class="input-group">
				<span class="input-group-addon">分类</span>
				<select name="" id="select" v-model="select" class="form-control" @change="changeChoose">
					<option v-for="(s,index) in selected" :value="index" :key='index'>{{s.name}}</option>
				</select>
			</div>
			<div class="equlist">
				<div v-for="(merchant,index) in merchants" :class="sub == index?'equItem-active':''" @click="changeMerchant(index)"
				 :key="index" class="equItem">
					{{merchant.merchantName}}
				</div>
			</div>
		</div>
		<div class="detial-mid" ref="midwidth" style="width:80%;margin-right: 5px;position: relative;">
			<div class="middle-row around" style="margin-bottom: 10px;position: relative;">
				<div class="input-group" style="width: 30%;">
					<span class="input-group-addon">查询项目</span>
					<select name="" id="item" v-model="itemindex" class="form-control" @change="changeItem">
						<option v-for="(target,i) in items" :value="i" :key='i'>{{target}}</option>
					</select>
				</div>
				<div class="input-group" style="width: 30%;">
					<span class="input-group-addon">查询时间段</span>
					<input type="text" id="start" class="form-control">
				</div>
				<div>
					<button type="button" class="btn btn-primary" @click="queryByTime" style="margin-right: 10px;">查询</button>
				</div>
			</div>

			<div id="myChart" style="background-color: #f5f5f5;" ref='mychart'>

			</div>
		</div>
	</div>
</template>

<script>
	import echarts from 'echarts'
	
	export default {
		props: ['upwidth'],
		data() {
			return {
				id: '',
				totalwidth: "0",
				selected: [{
					name: '餐饮油烟排放',
					java: 'Lampblack',
					files: ['油烟浓度', '颗粒物浓度', '非甲烷总烃'],
					way: 'queryLampblack',
					engfiles: ['lc', 'pc', 'nmthc']
				}, {
					name: 'VOCS排放',
					java: 'OuterDoor',
					files: ['VOCS排放'],
					way: 'queryOutDoor',
					engfiles: ['vocs']
				}, {
					name: '工地扬尘',
					java: 'Dust',
					files: ['pm2.5', 'pm10', '噪声', '温度', '湿度', '风力', '风向', '风速'],
					way: 'queryDust',
					engfiles: ['pm25', 'pm10', 'noise', 'temp', 'humidity', 'wp', 'wd', 'ws']
				}, {
					name: '工业企业废气',
					java: 'CarRepair',
					files: ['苯', '苯系物', '非甲烷总烃', '温度', '颗粒物'],
					way: 'queryCarRepair',
					engfiles: ['bz', 'bzs', 'nmthc', 'temp', 'pc']
				}],
				select: 0,
				items: ['油烟浓度', '颗粒物浓度', '非甲烷总烃'],
				itemindex: 0,
				start: '',//查询开始日期
				end: '',//查询结束日期
				merchants: [],//对应商户列表
				merchant: {},//选中某一个商铺
				sub: 0,//设备列表
				way: 'queryLampblack',//查询路径
				charts: '',//echarts对象
				datetime: ['请选择时间范围后查询'], //查询后指定的时间集合，用于在echart中绑定横向时间轴
				data: ['0'], //查询后指定的数据集合，用于在echart中绑定折线图的值
				resultlist: [], //查询的总结果，包括所有item中的监测值
				equId:'',
				type:''
			}
		},
		methods: {
			drawLine() {
				// 基于准备好的dom，初始化echarts实例
				this.charts = echarts.init(this.$refs.mychart);
				// 绘制图表
				this.charts.setOption({
					title: {
						text: this.items[this.itemindex],
						left: 'center',
						fontSize: 30
					},
					xAxis: {
						type: 'category',
						data: this.datetime
					},
					yAxis: {},
					grid:{
						left:'40px',
						right:'40px'
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross'
						},
						backgroundColor: 'rgba(245, 245, 245, 0.8)',
						borderWidth: 1,
						borderColor: '#ccc',
						padding: 10,
						textStyle: {
							color: 'black'
						}
					},
					color: {
					    type: 'linear',
					    x: 0,
					    y: 0,
					    x2: 0,
					    y2: 1,
					    colorStops: [{
					        offset: 0, color: 'red' // 0% 处的颜色
					    }, {
					        offset: 1, color: '#5cb85c' // 100% 处的颜色
					    }],
					    global: false // 缺省为 false
					},
					dataZoom: [{
						type: 'slider',
						show: true,
						xAxisIndex: [0],
						start: 1,
						end: 40
					}, ],
					series: [{
						type: 'line',
						data: this.data,
						markPoint: {
						    data: [
						        {type: 'max', name: '最大值'},
						        {type: 'min', name: '最小值'}
						    ]
						},
						markLine: {
						    data: [
						        {type: 'average', name: '平均值'}
						    ]
						}
					}, ]
				},true);
			},
			changeChoose: function() {
				this.items = this.selected[this.select].files;
				this.way = this.selected[this.select].way;
				this.$http.get(this.GLOBAL.base + 'getMerchants', {
					params: {
						target: this.selected[this.select].name
					}
				}).then(function(e) {
					this.merchants = e.body;
					this.sub = 0;
					this.itemindex = 0;
					this.merchant = this.merchants[0];
					this.drawLine();
				})
			},
			changeItem: function(n) {
				this.data = [];
				for (var result of this.resultlist) {
					//console.log(result)
					this.data.push(result[this.selected[this.select].engfiles[this.itemindex]])
				}
				this.charts.clear();
				this.drawLine();
			},
			queryByTime: function(e) {
				this.$http.get(this.GLOBAL.base + this.way, {
					params: {
						start: this.start,
						end: this.end,
						type: this.selected[this.select].java,
						equNum: this.merchant.equNum
					}
				}).then(function(res) {
					this.merchant = this.merchants[this.sub]
					this.resultlist = res.body;
					//如果查询结果为空
					if (this.resultlist.length == 0) {
						this.datetime = ['该时间段内无数据'];
						this.data = [100];
						this.drawLine();
						alert('该时间段内无数据！')
						return;
					}
					this.datetime = [];
					this.data = [];
					var date = new Date();
					for (var result of this.resultlist) {
						//console.log(result)
						date.setTime(result.time);
						var stringtime = date.getDate() + '日' + date.getHours() + '时';
						this.datetime.push(stringtime);
						this.data.push(result[this.selected[this.select].engfiles[this.itemindex]])
					}
					this.charts.clear();
					this.drawLine();
				}, function(error) {

				})
			},
			//选择左侧设备列表，更新sub，更新设备
			changeMerchant: function(n) {
				this.sub = n;
				this.merchant = this.merchants[n];
			},

		},
		mounted() {
			if (this.$route.query.equId) {//如果路由传过来设备编号
				this.equId = this.$route.query.equId;
			}else{
				//否则默认查询油烟设备列表
				this.$http.get(this.GLOBAL.base + 'getMerchants', {
					params: {
						target: '餐饮油烟排放'
					}
				}).then(function(e) {
					this.merchants = e.body;
					this.merchant = this.merchants[0];
					this.drawLine();
				})
			}
			if (this.$route.query.type) {
				this.type = this.$route.query.type;
			}
			
			this.totalwidth = this.$parent.sonwidth * 0.8 - 5;
			var that = this;
			//日期选择空间，获取用户选择的时间段
			laydate.render({
				elem: '#start', //指定元素.
				type: 'datetime',
				range: true,
				format: 'yyyy-MM-dd HH:mm:ss',
				done: function(value, startData, endData) {
					that.start = startData.year + '-' + startData.month + '-' + startData.date + ' ' + startData.hours + ':' +
						startData.minutes + ':' + startData.seconds;
					that.end = endData.year + '-' + endData.month + '-' + endData.date + ' ' + endData.hours + ':' + endData.minutes +
						':' + endData.seconds;
				}
			});
		},
		watch: {
			upwidth: function(val) {
				this.totalwidth = val;
			},
		}
	}
</script>

<style>
	#select {
		width: 100%;
		margin: 0 auto;
	}

	.equlist {
		width: 100%;
		background-color: white;
		position: absolute;
		top: 40px;
		bottom: 0px;
		left: 0px;
		overflow-y: scroll;
		border: 1px solid #CCCCCC;
		border-radius: 5px;
	}

	.equItem {
		margin: 10px 5px;
		background-color: #f3f3f5;
		padding: 10px;
	}

	.equItem-active {
		background-color: #5FB878;
		color: white;
		font-weight: bold;
	}

	#myChart {
		position: absolute;
		top: 40px;
		left: 0rem;
		right: 0px;
		bottom: 0px;
	}
</style>
